import { MenuContainer } from '~/modules/elements/menu';
import Modal from '~/modules/elements/modal';
import commitMicSetup from '~/routes/select-input/commit-mic-setup';
import SelectInputView, { MIC_SETUP_CARD } from '~/routes/select-input/select-input-view';

interface Props {
  onClose: () => void;
  open: boolean;
}

export default function SelectInputModal({ onClose, open }: Props) {
  // The backdrop never reaches `SelectInputView`, so it commits here. Clicking away from a screen
  // whose whole content is the setup is not a way of discarding it.
  const closeFromBackdrop = () => {
    commitMicSetup();
    onClose();
  };

  return (
    <Modal onClose={closeFromBackdrop} open={open}>
      {open && (
        <MenuContainer modal className={MIC_SETUP_CARD} data-test="mic-setup-modal">
          <SelectInputView onFinish={onClose} canGoBack />
        </MenuContainer>
      )}
    </Modal>
  );
}
